export const locales = {
    letsTalk: 'button.letsTalk',
    blogs: 'blogs'
};
